import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { AccountService } from 'app/core';
import { AccountFunctionsService } from './account-functions.service';
import { AccountFunction } from './account-functions.types';

@Injectable({
  providedIn: 'root',
})
export class AccountFunctionsResolver {
  /**
   * Constructor
   *
   * @param {Router} _router
   * @param {ProjectsService} _projectsService
   */
  constructor(
    private _router: Router,
    private _projectsService: ProjectsService,
    private _accountFunctionService: AccountFunctionsService,
    private _accountService: AccountService,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._accountFunctionService.accountId = accountData.id;
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Resolver
   *
   * @param route
   * @param state
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AccountFunction[]> {
    return this._accountFunctionService.getAccountFunctions();
  }
}

@Injectable({
  providedIn: 'root',
})
export class AccountFunctionResolver {
  /**
   * Constructor
   *
   * @param {Router} _router
   * @param {ProjectsService} _projectsService
   */
  constructor(
    private _router: Router,
    private _projectsService: ProjectsService,
    private _accountFunctionService: AccountFunctionsService,
    private _accountService: AccountService,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._accountFunctionService.accountId = accountData.id;
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Resolver
   *
   * @param route
   * @param state
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AccountFunction> {
    return this._accountFunctionService.getAccountFunctionById(route.paramMap.get('id')).pipe(
      // Error here means the requested mail is either
      // not available on the requested page or not
      // available at all
      catchError((error) => {
        // Log the error
        console.error(error);

        // Get the parent url
        const parentUrl = state.url.split('/').slice(0, -1).join('/');

        // Navigate to there
        this._router.navigateByUrl(parentUrl);

        // Throw an error
        return throwError(error);
      }),
    );
  }
}
